import { createValidation } from '../../../utils/validation';

export const createEmployeeValidation = (config) => {
  return createValidation(config);
};

